import React from 'react';

import {
  AsyncSelectField,
  MCButton,
  MCError,
  TextAreaField,
  TextField
} from 'src/components/basic';
import { lang, remCss, uniqueArray } from 'src/helpers';
import LANG_CONST from 'src/helpers/lang/const';
import { MediaOrderDropBox } from 'src/components/complex';
import { BASE_ICONS } from 'components/svg';

export const AddGallery = ({ closeBtn, item, onSave, hide, isMain }) => {
  const [description, setDescription] = React.useState(item?.description);
  const [title, setTitle] = React.useState(item?.title);
  const [media, setMedia] = React.useState(item?.media || []);
  const [tags, setTags] = React.useState(item?.tags || []);
  const [loading, setLoading] = React.useState(false);
  const [invalid, setInvalid] = React.useState({});

  const save = async (e) => {
    e.preventDefault();
    setLoading(true);
    const result = await onSave({ id: item?.id, title, tags, description, media, isMain });

    if (result.ok) {
      hide();
    } else if (result.invalid) {
      setInvalid(result.invalid);
    }

    setLoading(false);
  };

  const isValidTagRecommendationsQuery = (inputValue) => {
    // Check if input is not empty
    if (!inputValue || inputValue.trim() === '') {
      return false;
    }

    // Check minimum length
    if (inputValue.length < 3) {
      return false;
    }
    // Custom validation (e.g., no special characters)
    const regex = /^[a-zA-Z0-9\s]+$/;
    return regex.test(inputValue);
  };

  const aspect = isMain ? 16 / 9 : 3 / 4;

  return (
    <form className='mc-popup-contain' onSubmit={save} style={{ maxWidth: remCss(640) }}>
      <div className='mc-modal-header'>
        <pre className='mc-popup-title'>
          {lang.t(item?.title ? LANG_CONST.buttons.edit_gallery : LANG_CONST.buttons.add_gallery)}
        </pre>
        {closeBtn}
      </div>
      <div className='mc-modal-body mc-flex-15-col'>
        <div className={'mc-flex-col'}>
          <TextField
            template={6}
            name={'title'}
            label={LANG_CONST.title}
            value={title}
            onChange={(n, v) => {
              setInvalid({});
              setTitle(v);
            }}
            invalid={invalid}
          />
        </div>
        <div className={'mc-flex-col'}>
          <TextAreaField
            template={6}
            label={LANG_CONST.description}
            value={description}
            onChange={(n, v) => {
              setInvalid({});
              setDescription(v);
            }}
            invalid={invalid}
            rows={3}
            name={'description'}
            placeholder={LANG_CONST.text.enter_word}
          />
        </div>

        {!isMain && (
          <div className={'mc-flex-col'} style={{ zIndex: 2 }}>
            <AsyncSelectField
              allowNew={true}
              template={6}
              isClearable={true}
              apiConfig={{
                url: 'clinic/gallery/tags',
                labelKey: 'text'
              }}
              isMultiple={true}
              name={'tags'}
              invalid={invalid}
              value={tags}
              onChange={(n, v, option) => {
                setInvalid({});
                setTags((old) => uniqueArray([...old, ...(option || []).map((o) => o.label)]));
              }}
              canProcess={isValidTagRecommendationsQuery}
              isValidNewOption={isValidTagRecommendationsQuery}
              placeholder={LANG_CONST.text.tag_placeholder}
              cacheOptions={false}
              blurInputOnSelect={false}
              label={LANG_CONST.tags}
            />
          </div>
        )}

        {tags.length > 0 && (
          <div className={'mc-flex mc-wrap mc-flex-start'}>
            {tags.map((tag) => (
              <MCButton
                key={tag}
                quaternary
                small
                rounded
                light
                style={{
                  paddingLeft: remCss(12),
                  paddingRight: remCss(8),
                  paddingTop: remCss(8),
                  paddingBottom: remCss(8)
                }}
              >
                {tag}
                <MCButton
                  quaternary
                  iconname={BASE_ICONS.CLOSE}
                  width={22}
                  type={'button'}
                  onClick={() => {
                    setTags((o) => o.filter((old) => old !== tag));
                  }}
                  style={{ height: remCss(22) }}
                />
              </MCButton>
            ))}
          </div>
        )}

        <div className={'mc-flex-col'}>
          <div className={'mc-label-418'}>{lang.t(LANG_CONST.media)}</div>
          <MediaOrderDropBox
            template={2}
            labelIcon={LANG_CONST.buttons.add_new}
            accept={{ 'image/*': [], 'video/*': [] }}
            dropImage={{ aspect }}
            value={media}
            onChange={(v) => {
              setInvalid({});
              setMedia(v);
            }}
          />
          {invalid?.media && <MCError label={LANG_CONST.media} error={invalid?.media} />}
        </div>
      </div>
      <div className='mc-modal-footer mc-flex'>
        <div className='mc-grow' />
        <MCButton
          medium
          primary
          radius
          light
          disabled={loading}
          type={'button'}
          onClick={hide}
          label={LANG_CONST.buttons.cancel}
        />
        <MCButton
          medium
          primary
          radius
          dark
          style={{ minWidth: remCss(155) }}
          disabled={loading}
          loading={loading}
          type={'submit'}
          label={lang.t(
            item?.title ? LANG_CONST.buttons.edit_gallery : LANG_CONST.buttons.add_gallery
          )}
        />
      </div>
    </form>
  );
};
